let SITE_HOST = 'https://www.geograftour.com/api/geoclient';
const hostName = window.location.hostname;

if (hostName === '127.0.0.1' || hostName === 'localhost') {
  SITE_HOST = `http://127.0.0.1:8000/api/geoclient`;
}

const apiConfig = {
  url: SITE_HOST,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
  credentials: 'include',
};

class Api {
  constructor({ url, headers, credentials }) {
    this._url = url;
    this._headers = headers;
    this._credentials = credentials;
  }

  _getResponse(res) {
    return res.json();
  }

  _request(endpoint, options) {
    return fetch(`${this._url}${endpoint}`, options).then(this._getResponse);
  }

  _addTokenToHeaders(token, headers) {
    if (token) {
      return {
        ...headers,
        Authorization: token,
      };
    } else {
      return headers;
    }
  }

  async updateToken(refreshToken) {
    try {
      const response = await this._request(`/auth/refresh/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          refresh: refreshToken,
        }),
      });
      if (response.token) {
        localStorage.setItem('token', response.token);
        localStorage.setItem('refresh', refreshToken);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        throw new Error(response.error)
      }
      return response;
    } catch (e) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      return e;
    }
  }

  login(form) {
    return this._request(`/auth/`, {
      method: 'POST',
      body: form,
    });
  }

  getQuotes(token) {
    if (token) {
      const headersWithToken = this._addTokenToHeaders(token, this._headers);

      return this._request(`/get_quotes/`, {
        method: 'GET',
        headers: headersWithToken,
      });
    } else {
      return Promise.reject('Token not provided');
    }
  }

  getQuote(token, quoteId) {
    if (token) {
      const headersWithToken = this._addTokenToHeaders(token, this._headers);

      return this._request(`/quote/${quoteId}/`, {
        method: 'GET',
        headers: headersWithToken,
      });
    } else {
      return Promise.reject('Token not provided');
    }
  }

  createQuote(token, tours) {
    if (token) {
      const headersWithToken = this._addTokenToHeaders(token, this._headers);

      return this._request(`/create/`, {
        method: 'POST',
        headers: headersWithToken,
        body: JSON.stringify(tours),
      });
    } else {
      return Promise.reject('Token not provided');
    }
  }

  updateQuote(token, tours, quoteId) {
    if (token) {
      const headersWithToken = this._addTokenToHeaders(token, this._headers);

      return this._request(`/update/${quoteId}/`, {
        method: 'PATCH',
        headers: headersWithToken,
        body: JSON.stringify(tours),
      });
    } else {
      return Promise.reject('Token not provided');
    }
  }
}

export const GeoclientApi = new Api(apiConfig);
